import React from 'react';
import { componentService } from 'js/services/component.service';

export const IdentityVerification = React.lazy(() => import(/* webpackChunkName: "identity-verification" */ './IdentityVerification'));

componentService.registerPageComponents({ 'identity-verification': IdentityVerification });
